import { SearchListItem } from './searchList';
import { SuggestedPhrase as SuggestedPhraseModel } from 'models/SuggestedPhrase';

export interface SuggestedPhraseProps extends SuggestedPhraseModel {
  reset: () => void;
  executeSearch: (url: string) => void;
  searchUrl: string;
}

export const SuggestedPhrase = (props: SuggestedPhraseProps) => (
  <SearchListItem
    reset={props.reset}
    ticket={props.ticket}
    url={`${props.searchUrl}?phrase=${props.phrase}`}
    selected={props.selected}
    executeSearch={props.executeSearch}
  >
    {props.phrase}
  </SearchListItem>
);
